import _extends from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/extends";
import _slicedToArray from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
var __jsx = React.createElement;
import PlayerWrapper from '@anm/components/PlayerWrapper';
import Container from '@anm/components/video-landings/Container';
import DataWrapper from '@anm/components/video-landings/DataWrapper';
import LandingCTA from '@anm/components/video-landings/LandingCTA';
import parseTemplateProps from '../../../helpers/parseTemplateProps';
import useContainerHeight from '../../../hooks/useContainerHeight';
import useFontStyles from '@anm/hooks/useFontStyles';
import useIsTopAligned from '../../../hooks/useIsTopAligned';
import usePlayerSizesByHeight from '../../../hooks/usePlayerSizesByHeight';
import useTemplateRefs from '../../../hooks/useTemplateRefs';

var BasicTemplate = function BasicTemplate(_ref) {
  var videoId = _ref.videoId,
      viewType = _ref.viewType,
      playerColor = _ref.playerColor,
      startTime = _ref.startTime,
      otherProps = _objectWithoutProperties(_ref, ["videoId", "viewType", "playerColor", "startTime"]);

  var _parseTemplateProps = parseTemplateProps(otherProps),
      cta = _parseTemplateProps.cta,
      meta = _parseTemplateProps.meta,
      theme = _parseTemplateProps.theme,
      hasFooter = _parseTemplateProps.hasFooter,
      previewSrc = _parseTemplateProps.previewSrc,
      videoRatio = _parseTemplateProps.videoRatio,
      playerProps = _parseTemplateProps.playerProps,
      layoutDirection = _parseTemplateProps.layoutDirection,
      isCustomization = _parseTemplateProps.isCustomization;

  var _useFontStyles = useFontStyles(),
      _useFontStyles2 = _slicedToArray(_useFontStyles, 2),
      buttonFontStyles = _useFontStyles2[0],
      metaFontStyles = _useFontStyles2[1];

  var _useTemplateRefs = useTemplateRefs(),
      containerRef = _useTemplateRefs.containerRef,
      playerWrapperRef = _useTemplateRefs.playerWrapperRef,
      landingCTARef = _useTemplateRefs.landingCTARef,
      dataWrapperRef = _useTemplateRefs.dataWrapperRef,
      landingMetaRef = _useTemplateRefs.landingMetaRef;

  var playerSizes = usePlayerSizesByHeight({
    viewType: viewType,
    videoRatio: videoRatio,
    containerRef: containerRef,
    landingCTARef: landingCTARef,
    playerWrapperRef: playerWrapperRef,
    layoutDirection: layoutDirection
  });
  var isTopAligned = useIsTopAligned({
    dataWrapperRef: dataWrapperRef
  });
  var containerHeight = useContainerHeight({
    hasFooter: hasFooter,
    containerRef: containerRef,
    isCustomization: isCustomization
  });
  return __jsx(Container, {
    variant: "basic",
    ref: containerRef,
    minHeight: containerHeight,
    topAligned: isTopAligned,
    hasFooter: hasFooter,
    viewType: viewType,
    layoutDirection: layoutDirection,
    isCustomization: isCustomization
  }, __jsx(DataWrapper, {
    cta: cta,
    meta: meta,
    videoId: videoId,
    playerColor: playerColor,
    layoutDirection: layoutDirection,
    landingCTARef: landingCTARef,
    dataWrapperRef: dataWrapperRef,
    landingMetaRef: landingMetaRef,
    colorTheme: theme,
    layoutVariant: "basic",
    CTAFontStyles: buttonFontStyles,
    fontStyles: metaFontStyles
  }), __jsx(PlayerWrapper, _extends({
    videoName: meta === null || meta === void 0 ? void 0 : meta.heading
  }, playerProps, {
    videoId: videoId,
    startTime: startTime,
    playerSizes: playerSizes,
    previewSrc: previewSrc,
    playerWrapperRef: playerWrapperRef
  })), __jsx(LandingCTA, {
    cta: cta,
    theme: theme,
    playerColor: playerColor,
    CTAref: landingCTARef,
    projectId: videoId,
    fontStyles: buttonFontStyles
  }));
};

export default BasicTemplate;